export default __webpack_public_path__ + "static/media/employee.86221055.png";